export default __webpack_public_path__ + "static/media/bread(3).e4b9fdd9.png";